module.exports = {"220273100":"岔路河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220273.json
// module id = 713
// module chunks = 0